// Types
import { Exhibit } from '../../../server/src/types';

import { sortByComparators } from 'utils/sortByComparators';

export const sortExhibits = (
  exhibits: Exhibit[] | undefined,
  sortBy: string
): Exhibit[] => {
  return sortByComparators(exhibits, sortBy, {
    naziv: (a, b) => a.name!.localeCompare(b.name!),
    'naziv-desc': (a, b) => b.name!.localeCompare(a.name!),
    datum: (a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    'datum-desc': (a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  });
};
